import { useEffect } from 'react';
import type { DocumentAsset } from '../../../services/admin/adminBackendServiceDocumentLibraryMixin';

const POLL_MS = 3000;

/** Polls `refresh` while any document is still PENDING (Office → PDF on the worker). */
export function useDocumentLibraryPolling(
  documents: DocumentAsset[],
  refresh: () => Promise<void>,
) {
  const isProcessing = documents.some((doc) => doc.status === 'PENDING');
  useEffect(() => {
    if (!isProcessing) return undefined;
    const timer = setInterval(() => void refresh(), POLL_MS);
    return () => clearInterval(timer);
  }, [isProcessing, refresh]);
  return isProcessing;
}
